// Copyright (C) 2023 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import {
  IonCol,
  IonGrid,
  IonRow,
} from "@ionic/react"
import { useLocales } from "react-localized"
import { ServiceNotAvailableModal, useSession } from "../../../lib"
import { CreateAccountComponent, ConsoleSectionContainer, LoginComponent } from "../components"
import { AccountClient } from "../../../api"
import ConsoleSectionPage from "./ConsoleSectionPage"


const CreateAccount: React.FC = () => {
  const {available, user, ...session} = useSession()
  const client = new AccountClient({
    onServiceNotAvailable: (response) => {
      session.setServiceNotAvailable(true)
    }
  })
  const {gettext} = useLocales()
  const onSubmit = async (data: any) => {
    const account = client.create({
      ...data,
      businessAddress: {
        ...data.businessAddress,
        address3: "",
        region: ""
      }
    })
    await account.persist()
  }

  return (
    <ConsoleSectionPage hideMenu noRedirect>
      <ServiceNotAvailableModal
        close={() => session.setServiceNotAvailable(false)}
        isOpen={!available}
      />
      <ConsoleSectionContainer
        booting={!session.ready}
        loginComponent={LoginComponent}
        ready={true}
        title={gettext("Create a new account")}
      >
        <IonGrid style={{paddingTop: "var(--section-padding)"}}>
          <IonRow className="main w-512">
            <IonCol>
              <CreateAccountComponent onSubmit={onSubmit} user={user}/>
            </IonCol>
          </IonRow>
        </IonGrid>
      </ConsoleSectionContainer>
    </ConsoleSectionPage>
  )
}


export {CreateAccount}